<template>
<v-container>
  <v-card>
    <v-card-text>
      <v-data-table
        dense
        :items="processosSeletivos"
        :headers="headersPS"
      >
      <template v-slot:[`item.salarioReferencia`]="{item}">
          <span v-text="formataEmReais(item.salarioReferencia)"></span>
      </template>
      </v-data-table>
      <v-card-actions>
        <v-btn @click="adicionarPS"
        >Adicionar <v-icon color="primary"> mdi-plus </v-icon></v-btn
        >
      </v-card-actions>
    </v-card-text>
  </v-card>     
  <v-row justify="center">
    <v-dialog v-model="dlgPS" persistent max-width="600px">
      <v-card>
        <v-card-title>Incluir Processo Seletivo</v-card-title>
        <form>
          <v-card-text>
            <v-text-field
              v-model="ps.descricao"
              label="Descricao"
              required
            ></v-text-field>
            <v-text-field v-model="ps.salarioReferencia" type="number" mask="##.##" required>
              <template #label>
                Salário Mínimo Referencial - R$
                <span class="red--text"><strong> *</strong></span>
              </template>
            </v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn class="mr-4" @click="salvarPS"> Salvar </v-btn>
            <v-btn @click="cancelarInclusaoPS"> Cancelar </v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
  </v-row>
</v-container>
</template>

<script>
import * as ProcessoSeletivoService from "@/services/ps.service";
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      dlgPS: false,
      ps:{},
      headersPS: [
        {
          text: "Descricao",
          align: "start",
          sortable: false,
          value: "descricao",
        },
        {
          text: "Salário Mínimo Referencial (R$)",
          align: "center",
          sortable: false,
          value: "salarioReferencia",                   
          },      
        { text: "Ações", value: "actions", sortable: false, align: "center" },
      ],
    }
  },
  mounted() {
  },
  methods : {
    adicionarPS() {
      this.dlgPS = true;
    },
    salvarPS() {
      this.$nprogress.start();
      ProcessoSeletivoService.create(this.ps)
        .then((res) => {
          this.$msg.success("Processo Seletivo salvo com sucesso!");
          this.dlgPS = false;
          this.ps = {};
          this.processosSeletivos.push(res.data);
        })
        .finally(() => this.$nprogress.done());
    },
    cancelarInclusaoPS() {
      this.ps = {};
      this.dlgPS = false;
    },
    formataEmReais(valor){      
      return valor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});    
    },
  },
  computed: {
    ...mapGetters({
      'chamadas':'chamadas/chamadasByPS',
      'processosSeletivos': 'processosSeletivos/list'
    }),
  }
};
</script>